import { render, staticRenderFns } from "./product-receive-log.vue?vue&type=template&id=1193fb3f&scoped=true&"
import script from "./product-receive-log.vue?vue&type=script&lang=js&"
export * from "./product-receive-log.vue?vue&type=script&lang=js&"
import style0 from "./product-receive-log.vue?vue&type=style&index=0&id=1193fb3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1193fb3f",
  null
  
)

export default component.exports